import axios from "axios";
import {
  DeleteNewsLetterRequest,
  DeleteNewsLetterSuccess,
  getAllnewsLetterFail,
  getAllnewsLetterRequest,
  getAllnewsLetterSuccess,
  newsLetterCreateFail,
  newsLetterCreateRequest,
  newsLetterCreateSuccess,
  newsLetterFail,
  newsLetterRequest,
  newsLetterSuccess,
} from "../slices/newsLetterSlice";
import { toast } from "react-toastify";
import { mainurl } from "./mainurl";

const baseurl = mainurl;

export const getNewsLetterEmails = async (dispatch) => {
  try {
    dispatch(newsLetterRequest());
    const { data } = await axios.get(`${baseurl}/get-all-email`);
    dispatch(newsLetterSuccess(data));
  } catch (error) {
    dispatch(
      newsLetterFail(error?.response?.data?.message || "Unable to load emails")
    );
  }
};

export const createnewsletter = (content) => async (dispath) => {
  try {
    dispath(newsLetterCreateRequest());
    const { data } = await axios.post(`${baseurl}/create-newsletter`, content, {
      withCredentials: true,
    });
    dispath(newsLetterCreateSuccess(data.createletter));
    toast.success("newsletter sended successfully");
  } catch (error) {
    const message =
      error?.response?.data?.message || "Unable to create newsletter";
    dispath(newsLetterCreateFail(message));
    toast.error(message);
  }
};

export const getAllNewsletter = async (dispatch) => {
  try {
    dispatch(getAllnewsLetterRequest());
    const { data } = await axios.get(`${baseurl}/get-allnewsletter`);
    dispatch(getAllnewsLetterSuccess(data.getAll));
  } catch (error) {
    const message =
      error?.response?.data?.message || "Unable to load newsletters";
    dispatch(getAllnewsLetterFail(message));
    toast.error(message);
  }
};

export const DeleteNewsletter = (id) => async (dispatch) => {
  try {
    dispatch(DeleteNewsLetterRequest());
    const { data } = await axios.delete(`${baseurl}/delete-allnewsletter/${id}`);
    dispatch(DeleteNewsLetterSuccess(data.deletednl));
    toast.success("newsletter deleted successfully");
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Unable to delete newsletter"
    );
  }
};
